import getConfig from 'next/config';
import { useRouter } from 'next/router';
import React from 'react';

import { DesktopHeader, MobileHeader } from '@sravni/react-header';
import { GlobalSearch } from '@sravni/react-search/lib/GlobalSearch';
import { SberPromo } from '@sravni/react-shared-components/lib/SberPromo';
import { useIsMobile } from '@sravni/react-utils';

import { useCurrentRegion } from '../store/hooks/locations';
import { useSiteSettings } from '../store/hooks/sitesettings';
import { useUser } from '../store/hooks/users';
import pageStyles from '../styles/page.module.scss';
import { TReviewListQuery } from '../types/router';

export function Header() {
  const { asPath, query } = useRouter() as TRouter<TReviewListQuery>;
  const isMobile = useIsMobile();
  const settings = useSiteSettings();
  const user = useUser();
  const currentRegion = useCurrentRegion();

  const searchUrl = getConfig().publicRuntimeConfig.publicUrl;

  const reviewPage = Boolean(query.id);

  const AlterableHeader = isMobile ? MobileHeader : DesktopHeader;

  return (
    <AlterableHeader
      currentRegion={currentRegion}
      settings={settings.header}
      user={user}
      enableTheme
      promo={<SberPromo />}
      className={!reviewPage && isMobile && pageStyles.mobileHeader}
      search={<GlobalSearch searchServiceHost={searchUrl} asPath={asPath} />}
    />
  );
}
